import React, { useState, useEffect } from 'react'
import { Flex, Box } from 'reflexbox'
import { useHistory, Link } from 'react-router-dom'

import { toast } from 'react-toastify'
import { Formik, Form } from 'formik'
import moment from 'moment'

import Button from 'components/Button'
import DataListingTable from 'components/DataListingTable'
import { Title, Text } from 'components/Typography'
import { TextField, SelectField } from 'components/Form'

import { getOrdersList } from 'services/giftCards'

const columns = [
  {
    Header: 'Pedido',
    accessor: 'id',
  },
  {
    Header: 'Parceiro',
    accessor: 'partner_name',
  },
  {
    Header: 'Status de pagamento',
    accessor: 'transaction_status',
  },
  {
    Header: 'Utilização',
    accessor: 'gift_cards_balance',
  },
  {
    Header: 'Descrição',
    accessor: 'description',
  },
  {
    Header: '',
    accessor: 'actions',
    disableSortBy: true,
  },
]

const initialValues = {
  search: '',
  transaction_status: undefined,
}

const selectOptions = [
  {
    label: 'Processando pedido',
    value: 'INITIATED',
  },
  {
    label: 'Aguardando pagamento',
    value: 'PENDING',
  },
  {
    label: 'Pagamento aprovado',
    value: 'COMPLETE',
  },
  {
    label: 'Pagamento cancelado',
    value: 'CANCELLED',
  },
  {
    label: 'Erro no pagamento',
    value: 'ERROR',
  },
]

const GiftCard = () => {
  const [tableData, setTableData] = useState([])
  const [isLoading, setIsLoading] = useState(true)
  const [sortBy, setSortBy] = useState(null)
  const [pagination, setPagination] = useState({
    currentPage: 1,
    pageSize: 10,
    totalPages: 1,
    totalRecords: 0,
  })
  const [filters, setFilters] = useState(null)

  const history = useHistory()

  const onSubmit = ({ search, transaction_status }) =>
    setFilters({
      ...(search && { search }),
      ...(transaction_status && { transaction_status: transaction_status.value }),
    })

  const handleTableDataFetch = ({ sortBy, currentPage, pageSize }) => {
    setSortBy(sortBy)
    setPagination({ ...pagination, currentPage, pageSize })
  }

  const fetchOrders = async () => {
    try {
      setIsLoading(true)
      const res = await getOrdersList({ sortBy, pagination, ...filters })
      setTableData(
        res.orders.map(order => ({
          ...order,
          expiration_date: order.expiration_date ? moment(order.expiration_date).format('DD/MM/YYYY') : '-',
          id: <Link to={`/staff/prepaid-partners/gift-card/order/${order.id}`}>{order.id}</Link>,
          actions: (
            <Flex justifyContent='space-between'>
              <Text
                as='a'
                href={order.transactions?.[0]?.boletos?.[0]?.payment_url}
                target='_blank'
                textDecoration='underline'
                color='turquoises.T300'
              >
                Boleto
              </Text>
              <Text
                as='a'
                href={order.transactions?.[0]?.boletos?.[0]?.receipt}
                target='_blank'
                textDecoration='underline'
                color='turquoises.T300'
              >
                Recibo
              </Text>
            </Flex>
          ),
        })),
      )
      setPagination(res.pagination)
    } catch (e) {
      console.log(e)
      toast.error('Aconteceu um erro ao resgatar os dados de pedidos, por favor tente novamente.')
    } finally {
      setIsLoading(false)
    }
  }

  useEffect(() => {
    if (sortBy) {
      fetchOrders()
    }
  }, [sortBy, pagination.currentPage, pagination.pageSize])

  useEffect(() => {
    if (pagination.currentPage === 1 && filters) {
      fetchOrders()
    }
    setPagination({ ...pagination, currentPage: 1 })
  }, [filters])

  return (
    <Flex flexDirection='column'>
      <Flex justifyContent='space-between' alignItems='center' mb={32}>
        <Title as='h3'>Cartões presentes</Title>
        <Box>
          <Button size='big' mr={24} onClick={() => history.push('/staff/prepaid-partners/gift-card/list')}>
            Lista de cartões
          </Button>
          <Button variant='secondary' onClick={() => history.push('/staff/prepaid-partners/gift-card/new-order')}>
            Novo pedido
          </Button>
        </Box>
      </Flex>

      <Formik initialValues={initialValues} onSubmit={onSubmit}>
        <Flex as={Form} mb={24}>
          <TextField name='search' label='Pesquisar' placeholder='Pesquisar' mr={24} />
          <SelectField
            name='transaction_status'
            label='Status de pagamento'
            placeholder='Status de pagamento'
            options={selectOptions}
            minWidth={282}
            mr={24}
          />
          <Button variant='secondary'>Filtrar</Button>
        </Flex>
      </Formik>

      <DataListingTable
        data={tableData}
        columns={columns}
        pagination={pagination}
        loading={isLoading}
        fetchData={handleTableDataFetch}
      />
    </Flex>
  )
}

export default GiftCard
